'use client'

import React, { createContext, useContext, useState, useCallback } from 'react'

export type TaggedVolunteer = { id: number; fullname: string }

type ProjectNotesTaggedContextValue = {
  taggedVolunteers: TaggedVolunteer[]
  setTaggedVolunteers: React.Dispatch<React.SetStateAction<TaggedVolunteer[]>>
  /** Section name for notification message (e.g. "Project General Notes", "Miscellaneous Description"). */
  noteSource: string
  setNoteSource: React.Dispatch<React.SetStateAction<string>>
}

const ProjectNotesTaggedContext = createContext<ProjectNotesTaggedContextValue | null>(null)

export function ProjectNotesTaggedProvider({ children }: { children: React.ReactNode }) {
  const [taggedVolunteers, setTaggedVolunteers] = useState<TaggedVolunteer[]>([])
  const [noteSource, setNoteSource] = useState<string>('Project General Notes')
  return (
    <ProjectNotesTaggedContext.Provider value={{ taggedVolunteers, setTaggedVolunteers, noteSource, setNoteSource }}>
      {children}
    </ProjectNotesTaggedContext.Provider>
  )
}

export function useProjectNotesTagged() {
  const ctx = useContext(ProjectNotesTaggedContext)
  if (!ctx) return { taggedVolunteers: [], setTaggedVolunteers: () => {}, noteSource: 'Project General Notes', setNoteSource: () => {} }
  return ctx
}
